import { Box, TextField, Typography, useTheme } from '@mui/material';
import React, { ChangeEvent, FC, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LocalTranslationContext } from '../../hooks/useLocalTranslation';

interface Props {
  secondaryColor: string;
  primaryColor: string;
  customFont: string;
  feedbackText: string;
  feedbackTitle: string;
  title: string;
  onChange: (value: string) => void;
}

const MoodBarometerComment: FC<Props> = (props) => {
  const { secondaryColor, primaryColor, customFont, title, feedbackText, feedbackTitle, onChange } =
    props;
  const theme = useTheme();
  const localContext = useContext(LocalTranslationContext);
  const { t: globalT } = useTranslation();
  const t = localContext ? localContext.t : globalT;
  const [feedback, setFeedback] = useState<string>('');
  const maxFeedbackChars = 300;

  useEffect(() => {
    onChange(feedback);
  }, [feedback]);

  const handleFeedbackChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length <= maxFeedbackChars) {
      setFeedback(e.target.value);
    }
  };

  return (
    <Box
      className="survey-feedback survey-feedback--trend"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        width: '100%',
      }}
    >
      <Typography
        className="survey-title survey-feedback-title"
        variant="h4"
        sx={{
          color: primaryColor,
          fontWeight: 'bold',
          mb: theme.spacing(6),
          fontFamily: customFont,
        }}
      >
        {title}
      </Typography>
      <Typography
        className="survey-feedback-label"
        variant="h6"
        sx={{
          color: secondaryColor,
          pt: theme.spacing(1),
          mb: theme.spacing(3),
          ml: theme.spacing(3),
          fontFamily: customFont,
        }}
      >
        {feedbackTitle}
      </Typography>
      <TextField
        className="survey-feedback-input"
        id="outlined-multiline-static"
        multiline
        rows={4}
        variant="outlined"
        placeholder={feedbackText}
        sx={{
          width: '96%',
        }}
        value={feedback}
        onChange={handleFeedbackChange}
      />
      <Typography
        className="survey-feedback-character-count"
        variant="body2"
        color="textSecondary"
        sx={{
          mb: theme.spacing(2),
          ml: theme.spacing(1),
          textAlign: 'left',
          fontFamily: customFont,
        }}
      >
        {feedback.length}/{maxFeedbackChars} {t('characters')}
      </Typography>
    </Box>
  );
};

export default MoodBarometerComment;
